<template>
  <div class="system_roles">
    <!-- 角色管理 -->
    <el-form>
      <el-row :gutter="20">
        <el-col :span="3">
          <el-input
            v-model.trim="queryData.model.nameZh"
            placeholder="角色名"
            clearable
            @clear="clear"
          />
        </el-col>
        <el-col :span="20" style="margin-left: -10px">
          <el-button
            type="primary"
            class="search"
            @click="search"
          >搜索</el-button>
          <el-button
            type="primary"
            class="search"
            @click="add_click"
          >添加角色</el-button>
        </el-col>
      </el-row>
    </el-form>
    <!-- table -->
    <el-table
      class="table"
      :data="tableData"
      :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }"
      style="width: 98.5%; margin-top: 30px; margin-left: 10px"
      highlight-current-row
      :default-expand-all="true"
      row-key="id"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      @current-change="handleCurrentChangeColor"
    >
      <el-table-column prop="code" label="标识"/>
      <el-table-column prop="nameZh" label="名称" />
      <!-- <el-table-column prop="nameEn" label="描述" /> -->
      <el-table-column prop="createTime" label="创建时间" />
      <el-table-column label="操作" width="235">
        <template slot-scope="scope">
          <el-button
            class="edeit"
            type="text"
            size="small"
            @click="handleEdit(scope.$index, scope.row)"
          >编辑</el-button>
          <el-button
            class="edeit"
            type="text"
            size="small"
            @click="handleDel(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="blank" />
    <!-- 分页 -->
    <el-pagination
      background
      :current-page="queryData.pageNum"
      :page-sizes="[15, 30, 50, 100, 200]"
      :page-size="queryData.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="35%"
      @close="close"
    >
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="标识:">
          <el-input
            v-model="form.code"
            style="width: 92%"
            placeholder="唯一标识，只能是字母、数字或下划线，添加后不能修改"
          />
        </el-form-item>
        <el-form-item label="名称:">
          <el-input v-model="form.nameZh" style="width: 92%" />
        </el-form-item>
        <!-- <el-form-item label="角色描述:">
          <el-input v-model="form.nameEn" style="width: 92%" />
        </el-form-item> -->
        <el-form-item label="权限列表:">
          <el-tree
            v-if="flage"
            ref="menu"
            :data="data"
            show-checkbox
            node-key="id"
            :default-expanded-keys="menuIdList"
            :default-checked-keys="menuIdList"
            :props="defaultProps"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="retunDialogVisible">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { get, post } from '@/utils/request'
// const momemt = require('moment')
export default {
  name: 'SystemManageRoleManage',
  components: {},
  data() {
    return {
      // 新增or编辑弹框标题(根据点击的新增or编辑按钮显示不同的标题)
      titleMap: {
        addEquipment: '添加角色',
        editEquipment: '编辑角色'
      },
      title: '',
      dialogStatus: '', // 新增或者编辑框标题
      dialogVisible: false,
      isDelete: '',
      flist: [],
      slist: [],
      slists: [],
      permissions: [],
      form: {
        nameZh: '',
        nameEn: '',
        parentId: '',
        code: '',
        menuList: [],
        id: ''
      },
      checkboxGroup1: [],
      checked2: false,
      data: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      flage: true,
      input: '',
      form1: {
        nameZh: ''
      },
      tableData: [],
      queryData: {
        pageNum: 1,
        pageSize: 15,
        model: {
          nameZh: ''
        }
      },
      total: 0,
      currentRow: null,
      roleList: [],
      menuIdList: []
    }
  },
  created() {
    this.getListData()
  },
  methods: {
    clear() {
      this.getListData()
    },
    handleCurrentChangeColor(val) {
      this.currentRow = val
    },
    retunDialogVisible() {
      const keys = this.$refs['menu'].getCheckedKeys()
      const oneList = this.$refs['menu'].getHalfCheckedKeys()
      const menuIds = keys.concat(oneList)
      const menuList = []
      menuIds.map((item) => {
        menuList.push(item)
      })
      this.form.menuList = menuList
      if (this.form.parentId == undefined) {
        this.form.parentId = 0
      }
      console.log(this.form)
      this.dialogVisible = false

      // delete this.form.menus;
      if (this.title === '添加角色') {
        post('/admin/role/addRole', this.form).then((res) => {
          if (res.data.code == 20000) {
            this.$message({
              message: '提交成功！',
              type: 'success'
            })
            this.getListData()
          }
        })
      } else {
        post('/admin/role/editRole', this.form).then((res) => {
          if (res.data.code == 20000) {
            this.$message({
              message: '提交成功！',
              type: 'success'
            })
            // location.reload()
            this.getListData();
          }
        })
      }
    },
    allList() {
      this.data = []
      post('/admin/menu/getAllMenu').then((res) => {
        // console.log(res.data);
        const list = res.data.data
        list.forEach((item) => {
          const obj = {}
          obj.children = []
          obj.id = item.id
          obj.label = item.name
          const children = item.children
          children.forEach((item1) => {
            const obj1 = {}
            obj1.id = item1.id
            obj1.label = item1.name
            obj.children.push(obj1)
          })
          this.data.push(obj)
        })
      })
    },
    search() {
      this.getListData()
    },
    close() {},
    handleDel(row) {
      this.$confirm('此操作将永久删除该角色, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          post('/admin/role/delete', { id: row.id }).then((res) => {
           if(res.data.code == 20000){
            this.$message.success(res.data.message)
            this.getListData()
           }else{
            this.$message.error(res.data.message)

           }
          })
        })
    },
    handleEdit(index, row) {
      this.title = '编辑角色'
      this.data = []
      this.allList()
      this.dialogVisible = true
      this.dialogStatus = 'editEquipment'
      // this.flage = false
      const id = row.id
      setTimeout(() => {
        post('/admin/role/findRole', { id }).then((res) => {
          // post("/admin/role/getRole", { id }).then((res) => {
          console.log(res.data.data);
          // this.form = res.data.data;
          this.form.id = row.id
          const { menuIdList, roleName, roleCode } =
            res.data.data
          this.form.nameZh = roleName
          this.form.code = roleCode
          const slist = res.data.data.menus
          slist.map((item) => {
            if (item.children.length > 0) {
              item.children.map((item1) => {
                this.slist.push(item1.id)
              })
            } else {
              this.slist.push(item.id)
            }
          })
          this.$refs.menu.setCheckedKeys(this.slist)
        })
      }, 500)
    },
    add_click() {
      this.title = '添加角色'
      this.data = []
      this.form = {}
      this.allList()
      this.dialogVisible = true
      this.dialogStatus = 'addEquipment'
    },
    handleSizeChange(val) {
      this.queryData.pageSize = val
      this.getListData()
    },
    handleCurrentChange(val) {
      this.queryData.pageNum = val
      this.getListData()
    },
    getListData() {
      post('/admin/role/page', this.queryData).then((res) => {
        this.total = res.data.data.total
        this.tableData = res.data.data.data
      })
    }
  }
}
</script>
